var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageLinks',{attrs:{"page":_vm.page,"links":_vm.links,"createLink":_vm.createLink,"updateLink":_vm.updateLink,"deleteLink":_vm.deleteLink}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }